import React, { useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';
import {
  buildTableStatusFilterOptions,
  parseCampaignStatusFilterValue,
} from '../../utils/campaignStatusFilterOptions';

interface CampaignStatusFilterDropdownProps {
  availableStatusIds?: number[];
  value?: number;
  onChange: (status: number | undefined) => void;
  placeholder?: string;
  fluid?: boolean;
}

/**
 * Dropdown de status para tabelas de campanha.
 * Opções derivadas dos contratos presentes na tabela (via API).
 */
const CampaignStatusFilterDropdown: React.FC<CampaignStatusFilterDropdownProps> = ({
  availableStatusIds = [],
  value,
  onChange,
  placeholder = 'Status',
  fluid = false,
}) => {
  const options = useMemo(() => {
    const statusOptions = buildTableStatusFilterOptions(availableStatusIds);
    return [
      { key: 'all', value: '', text: 'Todos os status' },
      ...statusOptions,
    ];
  }, [availableStatusIds]);

  const displayValue = value === undefined || value === null ? '' : String(value);

  return (
    <Dropdown
      selection
      compact
      clearable
      fluid={fluid}
      placeholder={placeholder}
      options={options}
      value={displayValue}
      onChange={(_, { value: nextValue }) => {
        if (nextValue === undefined || nextValue === null || nextValue === '') {
          onChange(undefined);
          return;
        }
        onChange(parseCampaignStatusFilterValue(nextValue));
      }}
    />
  );
};

export default CampaignStatusFilterDropdown;
